<div class="clearfix" *ngIf="!editing">
  <ng-container *ngIf="lessee">
    <div class="column-50">
      <label>Typ pachtýře</label>
      <div class="info">{{lessee.subjectType | projectSubjectTypeName}}</div>
      <ng-container *ngIf="lessee.companyName">
        <label>Název</label>
        <div class="info">{{lessee.companyName}}</div>
      </ng-container>
      <ng-container *ngIf="lessee.surname && lessee.firstName">
        <label>Jméno a příjmení</label>
        <div class="info">{{lessee | projectSubjectName:false:false}}</div>
      </ng-container>
    </div>
    <div class="column-50">
      <label>IČO</label>
      <div class="info">{{lessee.identificationNumber || '-'}}</div>
      <label>Adresa</label>
      <div class="info">{{lessee | fulladdress}}</div>
    </div>
  </ng-container>
  <div class="empty-info" *ngIf="!lessee">Na případu není evidován pachtýř.</div>
  <div class="column-100 mt-10" *ngIf="!locked">
    <a class="button" (click)="edit()">{{lessee ? 'Změnit pachtýře' : 'Vybrat pachtýře'}}</a>
  </div>
</div>

<div *ngIf="editing">
  <gmt-lessee-select [selection]="selection" [required]="!!lessee"></gmt-lessee-select>
  <div class="mt-10">
    <gmt-button [clickAction]="save" [gmtDisabled]="!canSave()">Uložit</gmt-button>
    <a class="button ml-5" (click)="cancel()">Zrušit</a>
  </div>
</div>
